/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
//dev 
/*
"aws_api_key":"da2-mgadwqto4vgbfoldpuk4aysw5q",
"aws_appsync_graphqlEndpoint": "https://uwvv6ycgkfe2lgxaunv6edbcty.appsync-api.us-east-1.amazonaws.com/graphql",
"clientId": "2dff7dbe-a18a-4c19-b5ea-bd3e7b735080",

*/
//qa 
/*
  
  "aws_api_key":"da2-sa47gsnl7bfs5fcrxkqxifoz5u",
   "aws_appsync_graphqlEndpoint": "https://qa2.api.mobilestorm.nbcuni.com/graphql",
   "clientId": "2dff7dbe-a18a-4c19-b5ea-bd3e7b735080",
*/
//stg 
/*
 "aws_api_key":"da2-wwagqinscrcxvo363iinab3que",
 "aws_appsync_graphqlEndpoint": "https://4k5fkuaxvjdfxft664s2xgne2i.appsync-api.us-east-1.amazonaws.com/graphql",
 "clientId": "2dff7dbe-a18a-4c19-b5ea-bd3e7b735080",
*/
//prod
/*
  "aws_api_key":"da2-nl5owmbcjnhvrlmgwfpvqaffhe",
  "aws_appsync_graphqlEndpoint": "https://bszzqaysqvcatmt7kvrjdhunqi.appsync-api.us-east-1.amazonaws.com/graphql",
  "clientId": "11094351-a57a-42bd-90ff-be708c475155"
*/

// non-MFA = 'NoMFA'    for prod 'MFAEnabled' for preprod AlwaysMFAEnabled
const awsmobile = {
 "aws_api_key":"da2-mgadwqto4vgbfoldpuk4aysw5q",
 "aws_appsync_graphqlEndpoint": "https://uwvv6ycgkfe2lgxaunv6edbcty.appsync-api.us-east-1.amazonaws.com/graphql",
 "clientId": "2dff7dbe-a18a-4c19-b5ea-bd3e7b735080",
  "aws_appsync_authenticationType": "apiKey",
  "oauth_base_url": "https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4",
   
  "logout": "https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4/oauth2/v2.0/logout",
  "oauth_scope": "openid profile email"
};


export default awsmobile;
